import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RestService } from './rest.service';


@Injectable({
  providedIn: 'root'
})
export class GenericServiceService {

  constructor(
    private restHttp: RestService
  ) { }
  public GETMealCategories(): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/GetAllMealCategories`);
  }
  public GETAllCitys(): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/City`);
  }
  public addMeal(mealmodel: any) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/Meals`, mealmodel);
  }
  public GETMeals(id): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/MealByMainMenu?MealMainId=${id}`);
  }
  //
  public getAllCountries(): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/Country`);
  }
  public getAllTags(): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/RestaurantTag`);
  }
  public getAllBatches(): Observable<any> {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/GetBatchesList`);
  }
  public SignIn(model: any) {
    return this.restHttp.requestAllowAnonymousPOST(`${this.restHttp.serverURL}/DispatcherLogin`, model);
 }
  public getCitWithId(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/CityById?countryId=${id}`);
  }
  public getCitWithCItyId(id) {
    return this.restHttp.requestAllowAnonymousGET(`${this.restHttp.serverURL}/CityById/${id}`);
  }
}
